import {ProductSelectSettings} from '@/settings/types';

const placeholderProductSelectSettings = {
  best_value_one_time_selector: {
    label: 'PACK',
    color: 'dark-ocean',
    badge_text: 'Best Value',
  },
  best_value_pack_sizes: [6],
  delivery_interval_label: 'Delivery every',
  delivery_selector_title: 'Choose Your Delivery',
  default_delivery_option: 'yearly_subscription',
  format_money_with_decimals: true,
  frequency_helper_button_label: 'Which Frequency is Right for Me?',
  frequency_helper_options: ['3+ People', '2 People', '1 Person'],
  frequency_helper_title: 'How Large is Your Household?',
  gifts_unlocked_label: '❖ Gifts Unlocked:',
  ignore_options: ['Delivery', 'Pack Size'],
  monthly_subscription_selector: {
    label: 'Monthly Subscription',
    description: 'Shipped monthly. Cancel, pause, or change anytime.',
    color: 'primary-blue',
    badge_text: 'Save 40% + 2 Free Gifts',
  },
  most_popular_one_time_selector: {
    label: 'PACK',
    color: 'accent-red',
    badge_text: 'Most Popular',
  },
  most_popular_pack_sizes: [3],
  multi_pack_variants: [],
  next_button_labels: ['NEXT'],
  offer_terms: 'if you subscribe by Jan. 17th',
  offer_text: 'Save Up to 40% + 3 Free Gifts',
  one_time_purchase_selector: {
    label: 'One-Time Purchase',
    description: 'Shipped once. No gifts applied.',
    color: 'dark-navy-black',
  },
  product_options_settings_map: [
    {
      color: 'Logo Lime',
      description:
        'A beautiful fragrance with fresh floral notes that will keep you smelling great.',
      name: 'Choose Your Scent',
      value: 'Fresh Scent',
    },
    {
      color: 'Primary Blue',
      description: 'Perfect for anyone who may be sensitive to fragrances.',
      name: 'Choose Your Scent',
      value: 'Fragrance Free',
    },
  ],
  shipping_guarantee: 'Shipping From Oregon 3-5 Days',
  step_order: 'variant_first',
  subscription_guarantee: 'No Contracts, Cancel Anytime',
  subscription_terms: '100% Risk Free, Money Back Guarantee',
  yearly_subscription_selector: {
    label: 'Yearly Subscription',
    description: 'Shipped annually, easy storage.',
    color: 'accent-red',
    badge_text: 'Save 40% + 3 Free Gifts',
  },
  youre_saving_label: "You're saving:",
} satisfies ProductSelectSettings;

export default placeholderProductSelectSettings;

export const v2ProductSelectSettings = {
  ...placeholderProductSelectSettings,
  next_button_labels: ['Choose Scent', 'Checkout'],
  step_order: 'delivery_first',
} satisfies ProductSelectSettings;
